type TypedWindow = globalThis.Window &
  typeof globalThis & {
    ScarabQueue: any
  }
export const typedWindow = typeof window !== 'undefined' ? (window as TypedWindow) : null
